<angular-editor [config]="editorConfig" [(ngModel)]="html" (click)="onTouched()" (ngModelChange)="onChange(html)"
	(change)="onChange(html)" (blur)="onChange(html)" (viewMode)="onChange(html)" data-cy="htmlEditor">
</angular-editor>